import React, { useEffect, useState } from "react";
import TabSelection from "../../../../components/commons/TabSelection";
import { onBoardingDetailVehicleOtherMenu } from "../data";
import { ArrowBack, RemoveRedEye } from "@material-ui/icons";
import { useNavigate } from "react-router";
import VehicleInfo from "./VehicleInfo";
import OtherDocumentsInfo from "./OtherInfo";
import DeletedInfo from "./DeletedInfo";
import { formatDateWithDays } from "../../../../helpers/formatDateWithDays";
import EditIcon from "../../../../assets/icons/lucide_edit.svg";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import RejectModal from "./RejectModal";
import ApprovalModal from "./ApprovalModal";
import mobioApi from "../../../../services";
import { toastMessage } from "../../../../helpers/toastMessage";
import RevertOnboarding from "../modals/RevertOnboarding";

const MargeRendering = ({ onboardingData, token }) => {
  const [menuType, setMenuType] = useState("vehicle_details");
  const navigate = useNavigate();
  const [documentData, setDocumentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rejectModel, setRejectModel] = useState(false);
  const [approveModel, setApproveModel] = useState(false);
  const [revertModel, setRevertModel] = useState(false);
  const [approveLoadingStatus, setApproveLoadingStatus] = useState(false);

  useEffect(() => {
    setLoading(true);

    if (onboardingData && onboardingData?.onBoardingDetail?.length > 1) {
      setDocumentData([]);
    } else if (onboardingData?.onBoardingDetail?.length === 1) {
      setDocumentData(onboardingData?.onBoardingDetail[0]);
    } else {
      setDocumentData([]);
    }

    setLoading(false);
  }, [onboardingData]);

  // api handling

  const approveAPI = async () => {
    try {
      setApproveLoadingStatus(true);
      if (!documentData?.id || !onboardingData?.user?.displayName) {
        const message = onboardingData?.user?.displayName
          ? "Id  is required"
          : "First, set the display name for this user.";
        toastMessage("error", message);
        return;
      }
      const api = mobioApi(token);
      const response = await api.approve({
        id: documentData?.id,
        displayName: onboardingData?.user?.displayName,
      });
      toastMessage("success", response?.data?.msg);
      documentData.verify = "Approved";
      setApproveModel(false);
    } catch (error) {
      toastMessage("error", error?.response?.data?.msg);
    } finally {
      setApproveLoadingStatus(false);
    }
  };

  const onboardingRevertAPI = async () => {
    try {
      setApproveLoadingStatus(true);
      if (!documentData?.id) {
        toastMessage("error", "Id  is required");
        return;
      }
      const api = mobioApi(token);
      const response = await api.onboardingRevert(documentData?.id);
      toastMessage("success", response?.data?.msg);
      documentData.verify = "Pending";
      setRevertModel(false);
    } catch (error) {
      toastMessage("error", error?.response?.data?.msg);
    } finally {
      setApproveLoadingStatus(false);
    }
  };

  return (
    <div>
      {onboardingData ? (
        <>
          {onboardingData?.onBoardingDetail?.length > 1 &&
          documentData?.length === 0 ? (
            <>
              <table className="custom-table-v3">
                <thead>
                  <tr>
                    <th>Car Name</th>
                    <th>Service Level</th>
                    <th>Capacity</th>
                    <th>Status</th>
                    {/* <th>Registered Date</th> */}

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <>
                      <tr>
                        <td colSpan={7}>
                          <div className="text-align-center">Loading...</div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {onboardingData?.onBoardingDetail?.map((row, index) => (
                        <tr key={index}>
                          <td>{row?.car?.carName}</td>

                          <td>{row?.car?.category}</td>
                          <td>{row?.car?.seatingCapacity}</td>
                          <td>{row?.verify}</td>
                          {/* <td>{formatDateWithDays(row?.createdAt)}</td> */}

                          <td>
                            <RemoveRedEye
                              className="cursor-pointer text-primary "
                              style={{ width: "23px", height: "23px" }}
                              onClick={() => {
                                setDocumentData(row);
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </table>
            </>
          ) : (
            <>
              <div className=" ">
                {/* main-section-spacing-md */}
                <div className="bg-white border-radius-8 px-28 pb-16 mb-16 pt-16">
                  <div className="flex align-item-center ">
                    {onboardingData?.onBoardingDetail?.length > 1 && (
                      <div className="mr-12">
                        <ArrowBack
                          className="cursor-pointer"
                          onClick={() => {
                            setDocumentData([]);
                            setMenuType("vehicle_details");
                          }}
                        />
                      </div>
                    )}

                    {/* tab menu start  */}
                    <div className="width-full ">
                      <div className="flex justify-content-between align-item-center">
                        <div>
                          <TabSelection
                            menu={onBoardingDetailVehicleOtherMenu}
                            defaultSelected={
                              onBoardingDetailVehicleOtherMenu[0].title
                            }
                            onMenuChange={(tab) => {
                              setMenuType(tab?.value);
                            }}
                          />
                        </div>
                        <div className="flex gap-12  align-item-center">
                          <div>
                            <div className="font-14">
                              Current Status : &nbsp;
                              <span
                                className={`${
                                  documentData?.verify === "Rejected"
                                    ? "name-badge-danger font-14"
                                    : "name-badge font-14"
                                }`}
                              >
                                {documentData?.verify}
                              </span>
                            </div>
                          </div>
                          {documentData?.verify !== "Approved" &&
                          documentData?.verify !== "Rejected" ? (
                            <>
                              <div className="ml-12">
                                <MOButtonV2
                                  text="APPROVAL"
                                  textColor="#ffffff"
                                  radius={4}
                                  backgroundColor="#29AEE6"
                                  onClick={() => {
                                    setApproveModel(true);
                                  }}
                                  height={30}
                                  fontSize={12}
                                  padding={"8px 32px"}
                                />
                              </div>
                              <div className="ml-12">
                                <MOButtonV2
                                  text="REJECT"
                                  textColor="#ffffff"
                                  radius={4}
                                  backgroundColor="#ff3b30"
                                  onClick={() => {
                                    setRejectModel(true);
                                  }}
                                  height={30}
                                  fontSize={12}
                                  padding={"8px 32px"}
                                />
                              </div>
                            </>
                          ) : (
                            <div className="ml-12">
                              <MOButtonV2
                                text="REVERT"
                                textColor="#ffffff"
                                radius={4}
                                backgroundColor="#29AEE6"
                                onClick={() => {
                                  setRevertModel(true);
                                }}
                                height={30}
                                fontSize={12}
                                padding={"8px 32px"}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* tab menu end   */}
                <div className="">
                  {loading ? (
                    <div className="text-align-center p-20 font-17">
                      Loading...
                    </div>
                  ) : (
                    <>
                      {menuType === "vehicle_details" && (
                        <VehicleInfo
                          onboardingData={documentData}
                          token={token}
                        />
                      )}
                      {menuType === "other" && (
                        <OtherDocumentsInfo
                          onboardingData={documentData}
                          token={token}
                        />
                      )}
                      {menuType === "deleted" && (
                        <DeletedInfo onboardingData={documentData} />
                      )}
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <></>
      )}

      {rejectModel && (
        <RejectModal
          modalOpen={rejectModel}
          setModalOpen={setRejectModel}
          token={token}
          onboardingData={documentData}
        />
      )}
      {approveModel && (
        <ApprovalModal
          modalOpen={approveModel}
          setModalOpen={setApproveModel}
          apiCall={approveAPI}
          callingStatus={approveLoadingStatus}
        />
      )}
      {revertModel && (
        <RevertOnboarding
          modalOpen={revertModel}
          setModalOpen={setRevertModel}
          apiCall={onboardingRevertAPI}
          callingStatus={approveLoadingStatus}
        />
      )}
    </div>
  );
};

export default MargeRendering;
